
export default {
  allAccounts: (state) => state.accounts,
  accountsLoading: (state) => state.accountsLoading,
  transitionAccount: (state) => state.transitionAccount,
  transitionMode: (state) => state.transitionMode
}
